// Shared API connection layer.
// Every request targets the current host over HTTPS, e.g. https://globlink.info/api/...
// Plain JS on purpose (the project is not TypeScript).

export const getApiBaseUrl = () => `https://${window.location.hostname}`;

const JSON_HEADERS = { 'Content-Type': 'application/json' };

/**
 * Low-level fetch against the API host. Returns the raw Response untouched,
 * so callers that need the status code or a non-JSON body can handle it.
 */
export const apiFetch = (path, options = {}) =>
  fetch(`${getApiBaseUrl()}${path}`, options);

/**
 * GET helper: returns parsed JSON, throws on a non-OK response.
 */
export async function apiGet(path) {
  const response = await apiFetch(path);
  if (!response.ok) throw new Error('Network response was not ok');
  return response.json();
}

/**
 * Send a JSON body (POST/PUT/DELETE). Returns the raw Response so the caller
 * decides whether to read the body / inspect the status.
 */
export const apiSend = (path, method, body) =>
  apiFetch(path, {
    method,
    headers: JSON_HEADERS,
    body: body === undefined ? undefined : JSON.stringify(body),
  });
